// Header Component
import { School } from "lucide-react";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { t } = useTranslation();

  return (
    <header className="flex items-center space-x-3">
      <div className="bg-blue-100 p-2 rounded-lg">
        <School className="w-6 h-6 text-blue-600" />
      </div>
      <div>
        <h1 className="text-2xl font-bold text-slate-900">
          {t("parentPortalHeader.welcome")}
        </h1>
        <p className="text-sm text-slate-500">
          {t("parentPortalHeader.subtitle")}
        </p>
      </div>
    </header>
  );
};

export default Header;
